import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Locale } from '@fxtr/i18n';
import { useAppContext } from '$util/AppContext';
import type { AppContextGlobal } from '$util/AppContextGlobal';
import { MegaNav } from '@/components/organisms/MegaNav';
import { CallUsNavButton } from '@/components/molecules/CallUsNavButton';
import { Button } from '@/components/atoms/Button';
import frTranslations from '@/components/organisms/MegaNav/translations/fr.json';
import enTranslations from '@/components/organisms/MegaNav/translations/en.json';
import type { MandatoryProp } from '@/types/react';
import { getPageOverviewLink } from '@/app/(landingPages)/(overview)/getPageOverviewLink';

import styles from './index.module.scss';

export interface PageTopMegaNavigationBarProps extends HTMLAttributes<HTMLDivElement> {
  readonly campaignId: MandatoryProp<string>;
}

/**
 * Templates have to be Server Components.
 * Might conditionally load components based on page context.
 */
export function PageTopMegaNavigationBar({
  campaignId,
  className,
  ...props
}: PageTopMegaNavigationBarProps): JSX.Element {
  const { locale } = useAppContext<AppContextGlobal>();

  const isEnGb = locale === Locale.EN_GB;
  const translations = isEnGb ? enTranslations : frTranslations;
  const callUsLink = {
    url: isEnGb ? '03308089527' : '0176390537',
    text: isEnGb ? '0330 808 9527' : '01 76 39 05 37',
  };
  const mainCtaText = isEnGb ? 'See our services' : 'Obtenir un devis';

  return (
    <div className={classNames(PageTopMegaNavigationBar.displayName, styles.component, className)} {...props}>
      <MegaNav showLoginLink translations={translations} dynamicBlogData={[]}>
        <CallUsNavButton
          className={styles.callUsCta}
          phoneNumber={callUsLink.url}
          buttonText={callUsLink.text}
        />
        <Button
          className={classNames(styles.toggleButton, className)}
          size="S"
          href={getPageOverviewLink(locale, campaignId)}
        >
          {mainCtaText}
        </Button>
      </MegaNav>
    </div>
  );
}
PageTopMegaNavigationBar.displayName = 'PageTopMegaNavigationBar';
